export default "/img/v11-0-0_fig3.0baa0f6f19cbd0fe199863e8a9e8b0dd.png";